import { render } from "./PublicNewsDetails.vue?vue&type=template&id=5b20effc"
import script from "./PublicNewsDetails.vue?vue&type=script&lang=js"
export * from "./PublicNewsDetails.vue?vue&type=script&lang=js"

import "./PublicNewsDetails.vue?vue&type=style&index=0&id=5b20effc&lang=css"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__